export const DropdownEntireObjectOption = "$$ENTIRE_OBJECT";
